import React from 'react';

export default function SkillBoardModal({ isOpen, onClose, onSave, children }) {
  if (!isOpen) return null;
  
  return (
    <div style={{ 
      position: 'fixed', 
      inset: 0, 
      background: 'rgba(0,0,0,0.4)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      zIndex: 1000 
    }} onClick={onClose}>
      
      <div style={{ 
        background: '#fff', 
        borderRadius: 12, 
        padding: 20, 
        width: 900,
        height: 600,
        boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box'
      }} onClick={e => e.stopPropagation()}>
        
        <div style={{ 
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          marginBottom: 16 
        }}>
          {children}
        </div>
        
        <div style={{ 
          marginTop: 'auto',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 8
        }}>
          <button 
            onClick={onClose} 
            style={{ 
              padding: '8px 12px', 
              borderRadius: 8, 
              border: '1px solid #ddd', 
              background: '#f5f5f5', 
              cursor: 'pointer' 
            }}
          >
            Закрыть
          </button>
          <button 
            onClick={onSave}
            style={{ 
              padding: '8px 12px', 
              borderRadius: 8, 
              border: '1px solid #6c2bd9', 
              background: '#7c3aed', 
              color: '#fff',
              cursor: 'pointer' 
            }}
          >
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
}